module.exports = __webpack_public_path__ + "static/media/small.b9c82a4a.jpg";